export const DEFAULT_ERROR_MESSAGE =
  "default.error.message";
